import { render, staticRenderFns } from "./KiosksItemsTable.vue?vue&type=template&id=3c8c8bb6&scoped=true"
import script from "./KiosksItemsTable.vue?vue&type=script&lang=ts"
export * from "./KiosksItemsTable.vue?vue&type=script&lang=ts"
import style0 from "./KiosksItemsTable.vue?vue&type=style&index=0&id=3c8c8bb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8c8bb6",
  null
  
)

export default component.exports